import type {
	PortfolioDetailResponseDTO,
	ServiceDetailDataDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { SERVICES_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/ServicesForm/servicesFormDefaults";
import type { ServicesFormInput } from "web_myplann/Portfolio/Forms/ServicesForm/servicesFormSchema";

export const mapPortfolioToServicesForm = (
	portfolio: PortfolioDetailResponseDTO,
): ServicesFormInput => {
	const data = portfolio.data as ServiceDetailDataDTO | undefined;

	return {
		name: portfolio.name ?? DEFAULTS.name,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		tariff: data?.tariff ?? DEFAULTS.tariff,
		commodityService: data?.commodityService ?? DEFAULTS.commodityService,
		unitOfMeasurement: data?.unitOfMeasurement ?? DEFAULTS.unitOfMeasurement,
		pricePerUnit: data?.pricePerUnit ?? DEFAULTS.pricePerUnit,
		fixedPriceByFrequency:
			data?.fixedPriceByFrequency ?? DEFAULTS.fixedPriceByFrequency,
		paymentFrequency: data?.paymentFrequency ?? DEFAULTS.paymentFrequency,
		depositAmount: data?.depositAmount ?? DEFAULTS.depositAmount,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
	};
};
